var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timelines-container"},_vm._l((_vm.images),function(image){return _c('div',{key:image.id,class:{
      'timeline-new-line': image.type === 'blank',
      'timeline-container': image.type !== 'blank',
    }},[(image.type !== 'blank')?_c('base-media',{attrs:{"collection":_vm.collection,"campaign":_vm.campaign,"asset":_vm.asset,"file":image}},[_c('timeline-single',{attrs:{"data":image}})],1):_vm._e()],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }